/* tslint:disable */
/* eslint-disable */

/**
 * deliveryProviderPortal delivery-provider-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

import { GeneratedApiClient, type GeneratedHttpClientConstraints, type RequestOptionsConstraint, HttpMethod, AuthStrategy, ShardingStrategy } from "../runtime";

import type {
    GetCommissionAndFeesOptionsApiResponse,
    GetCommissionAndFeesOptionsRequest,
    GetCuisineTypesResponse,
    IsPointInAllowedAreaRequest,
    IsPointInAllowedAreaResponse,
    PortalSignupGetSubmissionDataRequest,
    PortalSignupGetSubmissionDataResponse,
    PortalSignupSendSubmissionDataRequest,
    PortalSignupSendSubmissionDataResponse,
    StandardRequest,
} from '../models/index';

export interface HttpClientConstraints {
    Auth: AuthStrategy.NONE;
    Sharding: ShardingStrategy.NONE;
    StandardRequest: StandardRequest;
}



class ApiClientClass<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> extends GeneratedApiClient<THttpClientConstraints, TRequestOptions> {
        public publicGetCommissionAndFeesOptions = async (body: GetCommissionAndFeesOptionsRequest, opts?: TRequestOptions): Promise<GetCommissionAndFeesOptionsApiResponse>  => {
            return this.httpClient.sendRequest<GetCommissionAndFeesOptionsApiResponse>({
                path: '/deliveryProviderPortal/public/getCommissionAndFeesOptions',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public publicGetCuisineTypes = async (opts?: TRequestOptions): Promise<GetCuisineTypesResponse>  => {
            return this.httpClient.sendRequest<GetCuisineTypesResponse>({
                path: '/deliveryProviderPortal/public/getCuisineTypes',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public publicGetSubmissionData = async (body: PortalSignupGetSubmissionDataRequest, opts?: TRequestOptions): Promise<PortalSignupGetSubmissionDataResponse>  => {
            return this.httpClient.sendRequest<PortalSignupGetSubmissionDataResponse>({
                path: '/deliveryProviderPortal/public/getSubmissionData',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public publicIsPointInAllowedArea = async (body: IsPointInAllowedAreaRequest, opts?: TRequestOptions): Promise<IsPointInAllowedAreaResponse>  => {
            return this.httpClient.sendRequest<IsPointInAllowedAreaResponse>({
                path: '/deliveryProviderPortal/public/isPointInAllowedArea',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public publicSendSubmissionData = async (body: PortalSignupSendSubmissionDataRequest, opts?: TRequestOptions): Promise<PortalSignupSendSubmissionDataResponse>  => {
            return this.httpClient.sendRequest<PortalSignupSendSubmissionDataResponse>({
                path: '/deliveryProviderPortal/public/sendSubmissionData',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
}
// Split class actual prototype and type
export const ApiClient = ApiClientClass;
/**
 * When you use ApiClient class as a type it would include private / protected properties which leads
 * to a situation where 2 sources of the ApiClient are not equal.
 *
 * This situation can happen for example when a library depends on the whole ApiClient and consumer wants to pass
 * in its own ApiClient. That would lead to an error
 *
 * TS2345: Argument of type 'ApiClient<HttpClientConstraints, HttpRequestOpts>' is not assignable to parameter of type 'ApiClient<HttpClientConstraints, never>'.
 *  Property 'apiClientOptions' is protected but type 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>' is not a class derived from 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>'.
 */
export type ApiClient<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> = {
    [Key in keyof ApiClientClass<THttpClientConstraints, TRequestOptions>]: ApiClientClass<THttpClientConstraints, TRequestOptions>[Key];
};
